import Vue from 'vue'
import VueAzureUploader from 'vue-azure-blob-upload'

Vue.use(VueAzureUploader)
